import StoredLayout from '../../layouts/StoredLayout'
import Flags from './Flags'
export default StoredLayout(Flags)
